// extracted by mini-css-extract-plugin
export var projectPageLayout = "ProjectPageLayout-module--projectPageLayout--Yh4SY";
export var heading = "ProjectPageLayout-module--heading--2R7t6";
export var subheading = "ProjectPageLayout-module--subheading--3yBvq";